import React, { useState } from "react";
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import IconButton from "@mui/material/IconButton";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import ArrowCircleLeftIcon from "@mui/icons-material/ArrowCircleLeft";
import ArrowCircleRightIcon from "@mui/icons-material/ArrowCircleRight";
import FormatQuoteIcon from "@mui/icons-material/FormatQuote";

const allReviews = [
  {
    name: "John Miller",
    title: "Network Engineer",
    avatar: "J",
    content:
      "I recently used DirectCertify to prepare for my Cisco CCNA certification, and I couldn't be more satisfied with the service. The practice tests were spot on, covering all the key topics I needed to master. What impressed me the most was the detailed explanations provided for each question, which really helped me understand the material. The user interface is clean and easy to navigate, making the study process smooth. I passed my exam on the first try, and I owe a big part of that success to DirectCertify. Highly recommended!",
  },
  {
    name: "Sarah Thompson",
    title: "IT Consultant",
    avatar: "S",
    content:
      "As someone based in the UK, I was initially hesitant about using an online service like DirectCertify, but I'm so glad I did. The study materials were well-organized and up-to-date, which gave me confidence going into my Salesforce certification exam. The site also offers a great variety of mock exams, which I found incredibly useful for practicing under timed conditions. Customer support was also top-notch, promptly answering any questions I had. Passing my exam has opened new doors for my career, and DirectCertify played a crucial role in that achievement.",
  },
  {
    name: "Priya Kumar",
    title: "SAP Consultant",
    avatar: "P",
    content:
      "DirectCertify has been an invaluable resource for my recent SAP certification preparation. The content is thorough and aligns perfectly with the actual exam syllabus. What stood out to me was the affordability of the service, especially considering the high quality of the material. The platform is user-friendly, and I appreciated the instant access to practice tests and results. Thanks to DirectCertify, I cleared my exam with flying colors and can now advance in my career with confidence. I would definitely recommend it to anyone preparing for IT certifications.",
  },
];

function Reviews() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const reviewsPerPage = 3;

  const nextReviews = () => {
    setCurrentIndex(
      (prevIndex) => (prevIndex + reviewsPerPage) % allReviews.length
    );
  };

  const prevReviews = () => {
    setCurrentIndex(
      (prevIndex) =>
        (prevIndex - reviewsPerPage + allReviews.length) % allReviews.length
    );
  };

  const visibleReviews = [
    allReviews[currentIndex],
    allReviews[(currentIndex + 1) % allReviews.length],
    allReviews[(currentIndex + 2) % allReviews.length],
  ];

  return (
    <Container sx={{ mt: 5, mb: 10 }}>
      <Grid container spacing={2}>
        <Grid item md={7} xs={12}>
          <Typography
            variant="h2"
            sx={{
              fontSize: { xs: "30px", sm: "52px" },
              fontFamily: "Poppins",
              fontWeight: 700,
              textAlign: { xs: "center", sm: "center", md: "left" },
            }}
          >
            What Our Clients Say
          </Typography>
        </Grid>
        <Grid item md={5} xs={12}>
          <Box
            sx={{
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <IconButton
              onClick={prevReviews}
              aria-label="previous reviews"
              disabled
            >
              <ArrowCircleLeftIcon
                sx={{ color: "#E7E7E7", fontSize: "50px" }}
              />
            </IconButton>
            <IconButton
              onClick={nextReviews}
              aria-label="next reviews"
              disabled
            >
              <ArrowCircleRightIcon
                sx={{ color: "#27B1BB", fontSize: "50px" }}
              />
            </IconButton>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Grid container spacing={2}>
            {visibleReviews.map((review, index) => (
              <Grid item xs={12} md={4} key={index}>
                <Card
                  sx={{
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <CardHeader
                    avatar={
                      <Avatar sx={{ bgcolor: "red" }} aria-label="recipe">
                        {review.avatar}
                      </Avatar>
                    }
                    action={
                      <FormatQuoteIcon
                        sx={{ fontSize: "50px", transform: "rotate(180deg)" }}
                      />
                    }
                  />
                  <CardContent sx={{ flexGrow: 1 }}>
                    <Typography variant="body2">{review.content}</Typography>
                  </CardContent>
                  <CardActions>
                    <Stack>
                      <Typography
                        sx={{
                          color: "#1A1F22",
                          fontFamily: "Poppins",
                          fontWeight: "700",
                          fontSize: "18px",
                        }}
                      >
                        {review.name}
                      </Typography>
                      <Typography sx={{ color: "#565D6D", fontSize: "12px" }}>
                        {review.title}
                      </Typography>
                    </Stack>
                  </CardActions>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
}

export default Reviews;
